
type LenghtUnits = {
  mm: string | undefined;
  in: string | undefined;
}

type MassUnits = {
  kg: string | undefined;
  lb: string | undefined;
}

type LoadUnits = {
  n: string | undefined;
  lbf: string | undefined;
}

type TorqueUnits = {
  nm: string | undefined;
  inlbf: string | undefined;
  ftlbf: string | undefined;
}

type PowerUnits = {
  kw: string | undefined;
  hp: string | undefined;
  hpdin: string | undefined;
}

export type GeneralConversionState = {
  length: LenghtUnits;
  mass: MassUnits;
  load: LoadUnits;
  torque: TorqueUnits;
  power: PowerUnits;
};

// Reducer
type ConversionCategory = keyof Pick<
  GeneralConversionState,
  'length' | 'mass' | 'load' | 'torque' | 'power'
>;

type UpdateUnitAction = {
  type: 'update_unit';
  payload: {
    category: ConversionCategory;
    updatedUnits: Record<string, string>; // contains both the input and converted unit(s)
  };
};

type ResetCategoryAction = {
  type: 'reset_category';
  payload: {
    category: ConversionCategory;
  };
};

type ConversionAction =
  | UpdateUnitAction
  | ResetCategoryAction;


export const generalConversionInitialState: GeneralConversionState = {
  length: { mm: undefined, in: undefined },
  mass: { kg: undefined, lb: undefined },
  load: { n: undefined, lbf: undefined },
  torque: { nm: undefined, inlbf: undefined, ftlbf: undefined },
  power: { kw: undefined, hp: undefined, hpdin: undefined },
};

export const generalConversionReducer = (
  state: GeneralConversionState,
  action: ConversionAction
): GeneralConversionState => {
  switch (action.type) {
    case 'update_unit': {
      const { category, updatedUnits } = action.payload;

      return {
        ...state,
        [category]: {
          ...state[category],
          ...updatedUnits,
        },
      };
    }

    case 'reset_category': {
      const { category } = action.payload;
      const resetCategoryState = Object.keys(state[category]).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
      }, {} as Record<string, string | undefined>);

      return {
        ...state,
        [category]: resetCategoryState,
      };
    }

    default:
      return state;
  }
};
